import { createContext } from 'react';
import { useFiltersContext } from '../../../../../Dashboards/Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_SIH,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIH.INDICATORS,
            url: 'governanceroom/dashboard/sihsus/aih/revenueIndicators'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value
        }
    );

    const chartData =
        data && data.indicators && data.indicators[0]
            ? {
                  total_val_sh: data.indicators[0].total_val_sh || 0,
                  total_val_sp: data.indicators[0].total_val_sp || 0,
                  total_val_sadt: data.indicators[0].total_val_sadt || 0,
                  total_val_rn: data.indicators[0].total_val_rn || 0,
                  total_val_acomp: data.indicators[0].total_val_acomp || 0,
                  total_val_ortp: data.indicators[0].total_val_ortp || 0,
                  total_val_sangue: data.indicators[0].total_val_sangue || 0,
                  total_val_transp: data.indicators[0].total_val_transp || 0,
                  total_val_obsang: data.indicators[0].total_val_obsang || 0,
                  total_val_ped1ac: data.indicators[0].total_val_ped1ac || 0,
                  total_val_tot: data.indicators[0].total_val_tot || 0,
                  total_val_uci: data.indicators[0].total_val_uci || 0,
                  total_val_uti: data.indicators[0].total_val_uti || 0
              }
            : {
                  total_val_sh: 0,
                  total_val_sp: 0,
                  total_val_sadt: 0,
                  total_val_rn: 0,
                  total_val_acomp: 0,
                  total_val_ortp: 0,
                  total_val_sangue: 0,
                  total_val_transp: 0,
                  total_val_obsang: 0,
                  total_val_ped1ac: 0,
                  total_val_tot: 0,
                  total_val_uci: 0,
                  total_val_uti: 0
              };

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
